<div>
	<div class="activity-overview-header">
		<span>{{ 'activity-overview' | translate }}</span>
		@if (selectedService.getGroup().hasReviewerRole(true)) {
			<button
				type="button"
				class="btn link-btn edit-btn"
				(click)="editActivity()">
					{{ 'common_edit' | translate}}
			</button>
			<button 
				type="button" 
				class="edit-icon ficon-app-edit icon-btn"
				(click)="editActivity()">
			</button>
		}
	</div>
	<activity-info
		[activity]="activity"
		[viewFrom]="viewFrom.ACTIVITY_OVERVIEW"
		[hideNumOfAttempts]="true"
		[hideTimeLimit]="true"
		[hidePoints]="true"
		[hideInstructions]="true"
		[hideSourceMedia]="shouldHideSourceMedia()"
		[isOnDashboard]="true">
	</activity-info>
</div>
